(()=>{
 const el=document.getElementById('we-loader');if(!el)return;
 const reduced=matchMedia('(prefers-reduced-motion: reduce)').matches;
 let done=false;
 function leave(){if(done)return;done=true;el.classList.add('is-leaving');setTimeout(()=>el.remove(),reduced?120:650)}
 const image=el.querySelector('img');
 const artwork=image&&image.decode?image.decode().catch(()=>{}):Promise.resolve();
 const loaded=document.readyState==='complete'?Promise.resolve():new Promise(resolve=>window.addEventListener('load',resolve,{once:true}));
 const animation=artwork.then(()=>{if(done)return;el.classList.add('is-ready');return new Promise(resolve=>setTimeout(resolve,reduced?0:2000))});
 Promise.all([loaded,animation]).then(leave);
 setTimeout(leave,4000);
 window.addEventListener('pageshow',e=>{if(e.persisted)leave()});
})();